import React, { useState, useEffect } from "react";
import serviceProvider from '../../services/axios'
import { PowerBiView } from "./powerbi-view";
export const PowerBiController = (props) => {

	const segments = window.location.pathname.slice(1).split("/");
	const bi_type = segments[1];
	const plant_slug = segments[2];
	const [results, setResults] = useState([]);
	const user = JSON.parse(localStorage.getItem("userData"));
	const usid = user ? user.uid : 0;
	
	useEffect(() => {
		props.handleExpandFal();
				const search = async () => {
				const apiUrl = `/powerbi?param=${bi_type}&uid=${usid}&slug=${plant_slug}`;
				const { data } = await serviceProvider.get(apiUrl,true,{});
				setResults(data);
			};
			search();
	}, []);
	
	
	
	return <PowerBiView resultsData={results}  {...props} />;
};
